import { Button, ButtonGroup, Col, Container, Row } from 'reactstrap';
import '../Provisioning.css';
import { useHistory } from 'react-router-dom';
import React from 'react';
import NestedRouting from './routing';

export default function Porting() {
  const history = useHistory();

  return (
    <Container fluid>
      <div className="viewContainer">
        <ButtonGroup className="tab-group">
          <Button onClick={() => history.push('/provisioning/new-number')}>New Number</Button>
          <Button className="active" onClick={() => history.push('/provisioning/porting')}>
            Porting
          </Button>
          <Button onClick={() => history.push('/provisioning/e911')}>E911</Button>
          <Button onClick={() => history.push('/provisioning/routing')}>Routing</Button>
        </ButtonGroup>

        <Row>
          <Col md="12" className="text-left">
            <NestedRouting />
          </Col>
        </Row>
      </div>
    </Container>
  );
}
